import { PersonSmartSuggestModel } from "./person-smart-suggest.model";

export class PersonSmartSuggestionModel {
    Input: string;
    GoalId: number | null;
    SelectedInputEntries: PersonSmartSuggestModel[];
    SelectedRegionEntries: any;
    /**
     *
     */
    constructor(destination?: PersonSmartSuggestModel[], regionDestination?: any) {
        this.SelectedInputEntries = destination || [];
        this.SelectedInputEntries = regionDestination || [];
        this.Input = '';
        this.GoalId = null;
    }
}